module.exports = __webpack_public_path__ + "img/ilustracao-boas-vindas.2da3f888.png";